import isBrowser from "./is-browser"

const devicePixelRatio = () => {
  return (isBrowser && window.devicePixelRatio) || 1
}

export default devicePixelRatio
